"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { resolveIpfsUrlSync } from "@/components/ipfs/IPFSContext";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { useCompactMode } from "@/contexts/CompactModeContext";
interface WaveDropAuthorPfpProps {
  readonly drop: ApiDrop;
}
const WaveDropAuthorPfp: React.FC<WaveDropAuthorPfpProps> = t0 => {
  const $ = _c(17);
  const {
    drop
  } = t0;
  const compact = useCompactMode();
  let t1;
  if ($[0] !== drop.author.pfp) {
    t1 = drop.author.pfp ? resolveIpfsUrlSync(drop.author.pfp) : null;
    $[0] = drop.author.pfp;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const resolvedPfp = t1;
  const authorHandle = drop.author.handle;
  const profileHref = authorHandle ? `/${authorHandle}` : null;
  const tooltipUser = authorHandle ?? drop.author.id;
  const sizeClasses = compact ? "tw-h-8 tw-w-8" : "tw-h-10 tw-w-10";
  const containerClasses = `tw-relative tw-flex-shrink-0 ${sizeClasses} tw-rounded-lg tw-bg-iron-900 tw-overflow-hidden`;
  let t2;
  if ($[2] !== authorHandle || $[3] !== compact || $[4] !== resolvedPfp) {
    t2 = resolvedPfp ? <Image src={resolvedPfp} alt={authorHandle ? `${authorHandle}'s profile picture` : "Profile picture"} fill={true} sizes={compact ? "32px" : "40px"} className="tw-object-contain tw-rounded-lg tw-bg-transparent" /> : <div className="tw-h-full tw-w-full tw-bg-iron-900 tw-ring-1 tw-ring-inset tw-ring-white/10 tw-rounded-lg" />;
    $[2] = authorHandle;
    $[3] = compact;
    $[4] = resolvedPfp;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const avatarContent = t2;
  const handleClick = _temp;
  if (!profileHref) {
    let t3;
    if ($[6] !== avatarContent || $[7] !== containerClasses) {
      t3 = <div className={containerClasses}>{avatarContent}</div>;
      $[6] = avatarContent;
      $[7] = containerClasses;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    return t3;
  }
  const t3 = `View ${tooltipUser}'s profile`;
  const t4 = `${containerClasses} tw-block`;
  let t5;
  if ($[9] !== avatarContent || $[10] !== profileHref || $[11] !== t3 || $[12] !== t4) {
    t5 = <Link href={profileHref} prefetch={false} aria-label={t3} onClick={handleClick} className={t4}>{avatarContent}</Link>;
    $[9] = avatarContent;
    $[10] = profileHref;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5 || $[15] !== tooltipUser) {
    t6 = <UserProfileTooltipWrapper user={tooltipUser}>{t5}</UserProfileTooltipWrapper>;
    $[14] = t5;
    $[15] = tooltipUser;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export default WaveDropAuthorPfp;
function _temp(event) {
  event.stopPropagation();
}